/**
 * The tags Settings → Preferences → default tags offers: the platform's and every tag the room's tournaments
 * carry, read from the room's tag counts (`GET /api/rooms/{roomId}/tournament-tags`, known gap 35) rather than the
 * capped tournament list, which stopped at the newest 200. Every distinct spelling, alphabetically — the rule the
 * pane always had, so a room carrying `MIXED` and `Mixed` sees both, as before.
 */
export function defaultTagChoices(
  platformTags: readonly string[],
  usage: readonly { tag: string; tournaments: number }[],
): string[] {
  return [...new Set([...platformTags, ...usage.map((u) => u.tag)])].sort((a, b) => a.localeCompare(b));
}
